import React from "react";
import CustomersListView from "../components/CustomersListView";

const CustomerDetails: React.FC = () => {
  return (
    <div className="px-4 pt-4 flex-1 w-full pr-6">
      <CustomersListView />
    </div>
  );
};

export default CustomerDetails;
